import React, { useRef } from 'react'
import './Footer.css'

const navLinks = [
  { label: 'Home',     href: '#home' },
  { label: 'About',    href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Products', href: '#products' },
  { label: 'Contact',  href: '#contact' },
]

const socials = [
  { label: 'IG', href: 'https://www.instagram.com/ra_steg_hub?igsh=MXQwbW1xOWl2bnVjcg==', symbol: 'IG' },
  { label: 'LI', href: 'https://www.linkedin.com/company/rasteghub', symbol: 'in' },
]

export default function Footer() {
  const marqueeRef = useRef(null)

  return (
    <footer className='footer'>

      {/* ── Marquee strip ── */}
      <div className='footer-marquee' aria-hidden='true'>
        <div className='marquee-track' ref={marqueeRef}>
          {[...Array(3)].map((_, i) => (
            <span key={i} className='marquee-content'>
              Software Development&nbsp;<em>·</em>&nbsp;
              UI/UX Design&nbsp;<em>·</em>&nbsp;
              Social Media&nbsp;<em>·</em>&nbsp;
              SEO&nbsp;<em>·</em>&nbsp;
              Mentorship&nbsp;<em>·</em>&nbsp;
              Ready-Made Solutions&nbsp;<em>·</em>&nbsp;
            </span>
          ))}
        </div>
      </div>

      {/* ── Main footer body ── */}
      <div className='footer-body'>

        {/* Big brand statement */}
        <div className='footer-brand'>
          <p className='footer-eyebrow'>Since 2026</p>
          <h2 className='footer-wordmark'>
            Rasteg<span>Hub</span>
          </h2>
          <p className='footer-tagline'>
            We don't just build software —<br />
            we build the tools that build the future.
          </p>
        </div>

        {/* Right column: nav + socials */}
        <div className='footer-right'>
          <nav className='footer-nav'>
            <p className='footer-nav-label'>Navigate</p>
            {navLinks.map(link => (
              <a key={link.label} href={link.href} className='footer-nav-link'>
                <span className='link-arrow'>→</span> {link.label}
              </a>
            ))}
          </nav>

          <div className='footer-contact-block'>
            <p className='footer-nav-label'>Say Hello</p>
            <a href='mailto:hello@rasteghub.co.ke' className='footer-email'>
              hello@rasteghub.co.ke
            </a>
            <div className='footer-socials'>
              {socials.map(s => (
                <a key={s.label} href={s.href} target='_blank' rel='noopener noreferrer' className='footer-social' aria-label={s.label}>
                  {s.symbol}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Divider ── */}
      <div className='footer-divider'></div>

      {/* ── Bottom bar ── */}
      <div className='footer-bottom'>
        <p className='footer-copy'>
          © {new Date().getFullYear()} RastegHub. All rights reserved.
        </p>
        <p className='footer-made'>
          Developed by <a href='https://dkhulwael.vercel.app/' target='_blank' rel='noopener noreferrer'>Drusilla Khulwael (Founder)</a>
        </p>
      </div>

    </footer>
  )
}